import { useState } from 'react';
import axios from 'axios';
import { OTP_ACTIONS, PARTNERSHIP_URL } from '../constants/index';
import { useTranslation } from 'react-i18next';

export function useOtp({
  partnerId,
  email,
  mode,
  cardNumber,
  otpUuid,
  setOtpUuid,
  countryOfOperation
}) {
  const { t } = useTranslation();
  const [otpValue, setOtpValue] = useState('');
  const [otpError, setOtpError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOtpSubmit = async (onSuccess) => {
    if (otpValue.length !== 6) {
      setOtpError(t('MESSAGES.ENTER_VALID_OTP_MSG'));
      return;
    }
    setOtpError('');
    setIsSubmitting(true);
    try {
      await axios.post(
        `${PARTNERSHIP_URL}/employees/verification/${otpUuid}`,
        {
          code: otpValue,
          partnerId,
          email,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      setIsSubmitting(false);
      setOtpValue('');
      if (onSuccess) onSuccess();
    } catch (error) {
      setIsSubmitting(false);
      setOtpError(error.response?.data?.message || t('MESSAGES.OTP_VERIFICATION_FAILED'));
    }
  };

  const handleOtpResend = async () => {
    setOtpError('');
    setOtpValue('');
    try {
      const response = await axios.post(
        `${PARTNERSHIP_URL}/otp/resend`,
        {
          email,
          action: OTP_ACTIONS.PARTNERSHIP_EMAIL_VERIFICATION,
          mode,
          metadata: { cardNumber, partnerId },
          countryCode: countryOfOperation
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      if (response?.data?.data?.uuid) {
        setOtpUuid(response.data.data.uuid);
      }
    } catch (error) {
      setOtpError(error.response?.data?.message || t('MESSAGES.OTP_RESEND_FAILED'));
    }
  };

  return {
    otpValue,
    setOtpValue,
    otpError,
    setOtpError,
    otpUuid,
    setOtpUuid,
    isSubmitting,
    handleOtpSubmit,
    handleOtpResend
  };
}
